<template>
  <transition name="fade" appear>
  <div class="fixed z-40 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true" v-if="value">
    <div class="flex items-end sm:items-center xs:items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div class="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle xs:w-full sm:w-11/12"
          :class="sizeClass"
          v-click-outside="autoCerrarModal">
        <span
            class="block absolute right-4 top-2 font-bold cursor-pointer hover:text-blue-500 px-1 py-1"
            @click="cerrarModal">x</span>
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 ">
          <div>
            <div class="mb-2">
              <h2 class="text-center font-bold text-lg">{{ title }}</h2>
            </div>
            <slot name="body">
              <p>
                modal body
              </p>
            </slot>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-2 sm:px-6 sm:flex sm:flex-row-reverse">
          <slot name="footer">
            <button type="button" @click="$emit('input', false)"
                    class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
              Deactivate
            </button>
            <button type="button"
                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
              Cancel
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
export default {
  name: "modal",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    size: {
      type: String,
      default: 'lg'
    },
    exit_out:{
      type:Boolean,
      default:()=>true
    },
    autoclose: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    sizeClass: null
  }),
  methods: {
    cerrarModal() {
      if (this.value) {
        this.$emit('input', !this.value)
        this.$emit('exit')
      }
    },
    autoCerrarModal(){
      if(this.value && this.autoclose){
        this.$emit('input', !this.value)
        this.$emit('exit')
      }
    },
    calculateSize() {
      if (this.size === 'sm') {
        this.sizeClass = 'max-w-screen-sm'
      } else if (this.size === 'xs') {
        this.sizeClass = 'max-w-screen-xs'
      } else if (this.size === 'md') {
        this.sizeClass = 'max-w-screen-md'
      } else if (this.size === 'lgs') {
        this.sizeClass = 'max-w-screen-lg'
      }
      else {
        this.sizeClass = 'max-w-full min-h-full'
      }
    }
  },
  watch: {
    size() {
      this.calculateSize()
    }
  },
  mounted() {
    this.calculateSize()
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s linear;

}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-50%);
}
</style>
